// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8b71bb4d","455":"d911f2b3","977":"ba052742"}[chunkId] + ".chunk.js";
};